import { invariant } from '@streem/toolbox';
import { logger } from './logger';
import { StreemAPI } from '@streem/api';
export async function getInvitedUserFromCredentials(credentials) {
    try {
        const { invitation } = await StreemAPI.default.getCurrentInvitation();
        invariant(invitation, "Received successful GetCurrentInvitationResponse without an 'invitation'");
        logger.setContextValue('inviteId', invitation.invitationSid);
        return {
            id: credentials.streem_user_id,
            companyId: credentials.streem_company_id,
            invitation,
            exp: credentials.expires_in,
        };
    }
    catch (error) {
        logger.error({
            msg: 'Error getting current invitation',
            error: error,
        });
        throw error;
    }
}
//# sourceMappingURL=invite_user.js.map